import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "caution",
  "use": "caution-usage",
  "viewBox": "0 0 18 15",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 15\" id=\"caution\"><path d=\"M17.534 11.73L10.693.895C10.307.291 9.648.045 8.93.045c-.717 0-1.376.246-1.761.85L.328 11.73a2.09 2.09 0 001.762 3.214h13.683a2.09 2.09 0 001.761-3.214zm-8.603 1.41a1.14 1.14 0 110-2.278 1.14 1.14 0 010 2.278zM9.95 9.002a1.018 1.018 0 01-2.011.012L7.8 4.576a1.143 1.143 0 011.142-1.178 1.142 1.142 0 011.142 1.178L9.95 9.002z\" fill-rule=\"nonzero\" fill=\"#FFF\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol